'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

var _ActionTypes$FILTERS_;

import Immutable from 'immutable';
import { isString, pick } from 'underscore';
import { usageTrackerActions } from 'usage-tracker-redux';
import ActionTypes from '../../constants/ActionTypes';
import GoodFiltersAndPage from '../../constants/GoodFiltersAndPage';
import { EventTypes, Screens } from './constants';
var FILTERS_TO_TRACK = [GoodFiltersAndPage.SORT_BY, GoodFiltersAndPage.SUB_TYPE, GoodFiltersAndPage.PAGE_LAYOUT, GoodFiltersAndPage.INDUSTRY, GoodFiltersAndPage.TEMPLATE_PURPOSE, GoodFiltersAndPage.PROVIDER];

var filtersBeingUpdatedFromUrlNotUserInteraction = function filtersBeingUpdatedFromUrlNotUserInteraction(action) {
  return Immutable.Map.isMap(action.payload);
};

var getTrackAdjustedFilterPayload = function getTrackAdjustedFilterPayload(screen, value, filterType) {
  return {
    screen: screen,
    value_str: value,
    filter_type: filterType
  };
};

export default (_ActionTypes$FILTERS_ = {}, _defineProperty(_ActionTypes$FILTERS_, ActionTypes.FILTERS_OR_PAGE_UPDATED, function (action, state, dispatch) {
  if (filtersBeingUpdatedFromUrlNotUserInteraction(action)) {
    return;
  }

  var newParams = action.payload,
      meta = action.meta;
  var _meta$screen = meta.screen,
      screen = _meta$screen === void 0 ? Screens.DIRECTORY : _meta$screen;
  var value;
  var filterType;

  if (newParams[GoodFiltersAndPage.SEARCH_TERM]) {
    value = newParams[GoodFiltersAndPage.SEARCH_TERM];
    filterType = 'search';
  } else {
    var adjustedFilterArr = Object.keys(pick(newParams, FILTERS_TO_TRACK) || {});
    var adjustedFilter = adjustedFilterArr.length && adjustedFilterArr[0];

    if (adjustedFilter && isString(newParams[adjustedFilter])) {
      value = newParams[adjustedFilter];
      filterType = adjustedFilter;
    }
  }

  if (value && filterType) {
    dispatch(usageTrackerActions.track(EventTypes.ADJUSTED_FILTER, getTrackAdjustedFilterPayload(screen, value, filterType)));
  } else if (newParams[GoodFiltersAndPage.LIMIT]) {
    dispatch(usageTrackerActions.track(EventTypes.ADJUSTED_FILTER, getTrackAdjustedFilterPayload(screen, String(newParams.limit), GoodFiltersAndPage.LIMIT)));
  }
}), _defineProperty(_ActionTypes$FILTERS_, ActionTypes.TRACK_MULTISELECT_SELECTION, function (action, state, dispatch) {
  var _action$payload = action.payload,
      adjustedFilter = _action$payload.adjustedFilter,
      selection = _action$payload.selection;
  dispatch(usageTrackerActions.track(EventTypes.ADJUSTED_FILTER, getTrackAdjustedFilterPayload(Screens.DIRECTORY, selection, adjustedFilter)));
}), _defineProperty(_ActionTypes$FILTERS_, ActionTypes.CREATE_ASSET, function (action, state, dispatch) {
  var purchasedGoodsKey = action.payload.purchasedGoodsKey;
  dispatch(usageTrackerActions.track(EventTypes.CREATED_ASSET, {
    screen: Screens.MANAGE_PURCHASES,
    value_str: state.managePurchases.getIn(['purchasedGoods', purchasedGoodsKey, 'subType'])
  }));
}), _defineProperty(_ActionTypes$FILTERS_, ActionTypes.UNINSTALL_GOOD, function (action, state, dispatch) {
  dispatch(usageTrackerActions.track(EventTypes.UNINSTALL_GOOD, {
    screen: Screens.MANAGE_PURCHASES
  }));
}), _defineProperty(_ActionTypes$FILTERS_, ActionTypes.REDELIVERING_GOOD, function (action, state, dispatch) {
  dispatch(usageTrackerActions.track(EventTypes.REDELIVER_GOOD, {
    screen: Screens.MANAGE_PURCHASES
  }));
}), _defineProperty(_ActionTypes$FILTERS_, ActionTypes.GOOD_INFO_CLICK, function (action, state, dispatch) {
  var trackingData = action.trackingData;
  dispatch(usageTrackerActions.track(EventTypes.GOOD_INFO_CLICK, Object.assign({
    screen: Screens.DETAILS
  }, Object.assign.apply(Object, [{}].concat(_toConsumableArray(trackingData))))));
}), _ActionTypes$FILTERS_);